<template>
  <div>
    <div class="title-container">
      <i class="far fa-images"></i>
      <div class="title">
        <h5 class="name">กำลังแก้ไข {{popupName}}</h5>
        <small>จำนวนป๊อปอัพทั้งหมด: {{allItems.length}}</small>
      </div>
    </div>
    <div class="slide-editor-items-container">
      <div
        class="slider-item slider-item--new"
        @click.prevent="newPopup">
        <i class="fas fa-plus"></i>
        <p>เพิ่มป๊อปอัพใหม่</p>
      </div>
      <div
        v-for="(item, itemIndex) in allItems"
        :key="itemIndex">
        <div
          :class="getBannerStatus(item)"
          class="slider-item"
          :id="`item${itemIndex}`"
          :style="`${item.coverImage ? `background-image: url(${item.coverImage.urls.cover1280w720h})` : ''}`"
          @click.stop="$emit('update:selectedIndex', itemIndex)">
          <div
            class="is-editing"
            v-if="itemIndex === selectedIndex">
            กำลังแก้ไข
          </div>
          <!-- <div class="meta">
            <p>{{item.title | noLongerThan(24) }}</p>
          </div> -->
          <p class="pIsShowing">
            <i class="fas fa-eye"></i>
            กำลังแสดงผล
          </p>
          <p class="pPending">
            <i class="fas fa-hourglass-half"></i>
            แสดงผลในอีก {{ getPendingDays(item.startPublish) }} วัน
          </p>
          <p class="pEnded">
            <i class="fas fa-eye-slash"></i>
            สิ้นสุดแล้ว
          </p>
          <div class="slider-item-actions">
            <button
              class="btn-delete"
              @click.stop="deletePopupItem(itemIndex)"
              v-if="deleteConfirm !== itemIndex">
              <i class="fas fa-trash-alt"></i>
            </button>
            <button
              class="btn-delete-confirm"
              @click.stop="deletePopupItem(itemIndex)"
              v-if="deleteConfirm === itemIndex">
              <i class="fas fa-trash-alt"></i> ยืนยันการลบ
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import BannerMixins from '@/pageDesigner/mixins';

export default {
  props: {
    allItems: {
      type: Array,
      default: () => [],
    },
    selectedIndex: {
      type: Number,
      default: () => 0,
    },
    popupName: {
      type: String,
      required: true,
    },
  },
  mixins: [BannerMixins],
  data() {
    return {
      deleteConfirm: false,
      showAddSliderItemModal: false,
    };
  },
  methods: {
    hasItem() {
      return this.allItems;
    },
    newPopup() {
      const newPopup = {
        coverImage: null,
        mobileCoverImage: null,
        link: {
          url: '',
          target: '_blank',
        },
        startPublish: null,
        endPublish: null,
      };
      this.$emit('update:allItems', [newPopup, ...this.allItems]);
      this.$emit('update:selectedIndex', 0);
    },
    deletePopupItem(itemIndex) {
      if (this.deleteConfirm === itemIndex) {
        const allItems = _.cloneDeep(this.allItems);
        this.$delete(allItems, itemIndex);
        this.$emit('update:allItems', allItems);
        const previousIndex = (itemIndex - 1 >= 0) ? itemIndex - 1 : 0;
        this.$emit('update:selectedIndex', previousIndex);
        this.deleteConfirm = null;
      } else {
        this.deleteConfirm = itemIndex;
        setTimeout(() => {
          this.deleteConfirm = null;
        }, 1800);
      }
    },
    onReorder() {
      this.$emit('update:allItems', this.allItems);
    },
  },
  filters: {
    noLongerThan(text, length) {
      if (!text) {
        return 'Untitled Slide';
      }
      if (text.length > length) {
        return `${text.substring(0, length)} ...`;
      }
      return text;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/helpers.scss';

.popup-editor {
  .slide-editor-items-container {
    @extend .scrollbar;
    display: flex;
    flex-flow: row;
    overflow-x: scroll;
    padding: 10px;
    background: $altv-navy;
    -webkit-overflow-scrolling: touch;
    .draggable-container {
      display: flex;
      flex-flow: row;
    }
    .slider-item {
      position: relative;
      min-width: 256px;
      min-height: 144px;
      margin-right: 10px;
      background-color: #495057;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      cursor: pointer;
      .is-editing {
        position: absolute;
        cursor: default;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.67);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFF;
        z-index: 20;
      }
      .meta {
        position: absolute;
        top: 8px;
        left: 10px;
        z-index: 32;
        p {
          color: #FFF;
          margin: 0;
        }
      }
      .pIsShowing, .pPending, .pEnded {
        display: none;
        padding: 6px 10px 2px;
        border-radius: 0.25rem;
        position: absolute;
        bottom: 8px;
        right: 10px;
        z-index: 32;
        margin: 0;
        cursor: default;
      }
      .pIsShowing {
        background: $altv-mint;
        color: #FFF;
      }
      .pPending {
        background: $altv-orange;
        color: #FFF;
      }
      .pEnded {
        background: $gray-600;
        color: #FFF;
      }
      .slider-item-actions {
        position: absolute;
        width: 100%;
        height: 34px;
        background: rgb(0, 0, 0);
        background: -moz-linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.7) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        background: -webkit-linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.7) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.7) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#ffffff",GradientType=1);
        z-index: 21;
        .btn-delete {
          position: absolute;
          top: 6px;
          right: 4px !important;
          border: none;
          background: transparent;
          z-index: 22;
          i {
            font-size: 20px;
            color: #fff;
            color: rgba(255, 255, 255, 0.5);
            -webkit-transition: color 250ms ease;
            -moz-transition: color 250ms ease;
            -ms-transition: color 250ms ease;
            -o-transition: color 250ms ease;
            transition: color 250ms ease;
          }
          &:hover i {
            color: #FFF;
            color: rgba(255, 255, 255, 1);
          }
          &:focus {
            outline: none;
          }
        }
        .btn-delete-confirm {
          position: absolute;
          top: 0;
          right: 0;
          border: none;
          background: $red;
          font-size: 12px;
          padding: 8px;
          color: #fff;
          z-index: 200;
          i {
            font-size: 12px;
            color: #fff;
          }
          &:focus {
            outline: none;
          }
        }
      }
    }
    .slider-item.showing {
      .pIsShowing {
        display: block;
      }
    }
    .slider-item.pending {
      .pPending {
        display: block;
      }
    }
    .slider-item.ended {
      .pEnded {
        display: block;
      }
    }
    .slider-item.ended::before {
      content: " ";
      background: linear-gradient(to top left, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.6) 50%, rgba(0,0,0,0) calc(50% + 4px), rgba(0,0,0,0) 100%);
      position: absolute;
      width: 100%;
      height: 100%;
      display: block;
      top: 0;
      left: 0;
    }
    .slider-item.slider-item--new {
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      background: $gray-200;
      i {
        font-size: 32px;
        margin: 6px 0;
        color: $altv-navy;
        transition: color 250ms ease;
      }
      p {
        color: $altv-navy;
        margin: 0;
        transition: color 250ms ease;
      }
      &:hover {
        i, p {
          color: $altv-orange;
        }
      }
    }
  }
  .title-container {
    display: flex;
    flex-flow: row;
    width: 268px;
    padding: 16px 20px 6px;
    background: #052a55;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    i {
      font-size: 32px;
      color: #FFF;
    }
    .title {
      margin-left: 6px;
      h5 {
        color: #FFF;
        margin: 0;
        font-size: 16px;
      }
      small {
        display: block;
        color: #FFF;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .popup-editor {
    /* .slide-editor-items-container {
      .slider-item {
        min-width: 242px;
        min-height: 108px;
        margin-right: 10px;
      }
    } */
    .title-container {
      width: 262px;
      padding: 16px 12px 0;
      i {
        font-size: 22px;
      }
      .title {
        h5 {
          font-size: 15px;
          margin-bottom: 2px;
        }
      }
    }
  }
}
</style>
